export const priceSurveyProductsColumns = [
  { label: 'Produto', value: 'display_name' },
  { label: 'Preço médio', value: 'price' },
]
